// Wipes everything the signed-in provider left behind. Every logout path goes
// through here; removing only the token left the previous provider's
// half-filled add-parking-spot drafts (sessionStorage) for the next login.
export function clearProviderSession() {
  sessionStorage.clear();
  localStorage.removeItem("provider__token");
  localStorage.removeItem("selected");
}
